"use client";

import { useContactSalesFormV2 } from "./hooks/useContactSalesFormV2";
import * as m from "motion/react-m";
import { AnimatePresence } from "motion/react";
import { ResumePrompt } from "./components/ResumePrompt";
import { StepNavigation } from "./components/StepNavigation";
import Spinner20 from "@ui/icons/20x20/spinner-20.svg";

export function ContactSalesFormV2() {
  const { form, step, stepIndex, showResumePrompt, continueWithSavedForm, startFreshForm, steps } =
    useContactSalesFormV2();

  const currentStepData = steps[stepIndex];

  const stepAnimationVariants = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  };

  const navigationAnimationVariants = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  };

  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        void form.handleSubmit();
      }}
    >
      <div className='tw-mb-8'>
        <AnimatePresence mode='wait'>
          <div key={`header-${step}`}>
            <m.h2
              className='tw-type-5xl tw-mb-6'
              initial={false}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.25 }}
            >
              {currentStepData.title}
            </m.h2>
            <m.p
              className='tw-type-base tw-mb-9'
              initial={false}
              animate={{ opacity: 0.6 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.25 }}
            >
              {currentStepData.subtitle}
            </m.p>
          </div>
        </AnimatePresence>
      </div>
      <form.Subscribe selector={state => state.isSubmitting}>
        {isSubmitting => (
          <div className='tw-relative'>
            <AnimatePresence mode='wait'>
              <m.div
                key={`step-${step}`}
                initial={false}
                animate='animate'
                exit='exit'
                variants={stepAnimationVariants}
                transition={{ duration: 0.2 }}
              >
                <div
                  className={
                    isSubmitting
                      ? "tw-opacity-30 tw-pointer-events-none tw-transition-opacity tw-duration-300"
                      : "tw-transition-opacity tw-duration-300"
                  }
                >
                  {currentStepData.component}
                </div>
              </m.div>
            </AnimatePresence>
            {isSubmitting && (
              <m.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className='tw-absolute tw-top-1/3 tw-left-1/2 tw--translate-x-1/2 tw--translate-y-1/2'
              >
                <Spinner20 className='tw-text-gray-900 tw-scale-150' />
              </m.div>
            )}
          </div>
        )}
      </form.Subscribe>
      <AnimatePresence mode='wait'>
        <m.div
          key={`navigation-${step}`}
          initial={false}
          animate='animate'
          exit='exit'
          variants={navigationAnimationVariants}
          transition={{ duration: 0.2 }}
        >
          <StepNavigation
            navigation={currentStepData.navigation}
            currentStep={step}
            totalSteps={steps.length}
            form={form}
          />
        </m.div>
      </AnimatePresence>
      <ResumePrompt show={showResumePrompt} onContinue={continueWithSavedForm} onStartFresh={startFreshForm} />
    </form>
  );
}
